import hourglassImg from 'resource/img/hourglass.png';
import clippingImg from 'resource/img/clipping.png';
import calendarImg from 'resource/img/calendar.png';
import draftImg from 'resource/img/draft.png';
import mobileImg from 'resource/img/mobile.png';
import scalingImg from 'resource/img/scaling.png';

export const services = [
  {
    title: 'Calculadora de Prazos',
    img: hourglassImg,
    items: [
      '- Calculadora automática de prazos judiciais a partir das suas intimações trabalhistas.',
      '- Considera feriados e recessos forenses.',
    ],
  },
  {
    title: 'Gerenciamento de Intimações',
    img: clippingImg,
    items: [
      '- Gerenciamento das intimações, com marcação de prazos e medidas judiciais apropriadas para cada caso.',
      '- Fácil gestão das publicações.',
    ],
  },
  {
    title: 'Integração com o Google Calendar',
    img: calendarImg,
    items: [
      '- Espelhamento das suas intimações no seu calendário Google Calendar.',
      '- Mais agilidade e segurança para seu escritório.',
    ],
  },
  {
    title: 'Minutas Atualizadas',
    img: draftImg,
    items: ['- Minutas de todas as peças e recursos judiciais trabalhistas.'],
  },
  {
    title: 'Acesso por dispositivo móvel',
    img: mobileImg,
    items: ['- Mais praticidade e respostas mais rápidas aos seus clientes.'],
  },
  {
    title: 'Em breve muito mais',
    img: scalingImg,
    items: [
      '- Captura automática das suas publicações integrada com a Plataforma de Intimações da AASP. Segurança, ganho de tempo, mais resultados para o escritório.',
      '- Entrevista com cliente',
      '- Cálculo de Inicial',
    ],
  },
];
